export const quickpayConstants = {
    QUICK_PAY_SUCCESS: "QUICK_PAY_SUCCESS",
  };
  